import { render, staticRenderFns } from "./swipe.vue?vue&type=template&id=1a924c45"
import script from "./swipe.vue?vue&type=script&lang=js"
export * from "./swipe.vue?vue&type=script&lang=js"
import style0 from "./swipe.vue?vue&type=style&index=0&id=1a924c45&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports